import React from 'react';

import { classNames } from '@/helpers/classNames';
import { Button, IconButton } from '@material-ui/core';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';

import styles from './AsaphDialogHeaderButton.module.scss';

interface AsaphDialogHeaderButtonProps {
	type: 'icon' | 'text';
	label: string;
	textClassName?: string;
	className?: string;
	handlePress: () => void;
	disabled?: boolean;
}

export const AsaphDialogHeaderButton: React.FC<
	AsaphDialogHeaderButtonProps
> = ({
	type,
	label,
	handlePress,
	disabled = false,
	textClassName,
	className,
	children,
}) => {
	if (type === 'icon') {
		return (
			<IconButton
				aria-label={label.toLowerCase()}
				onClick={handlePress}
				classes={{
					root: classNames([
						styles['dialog-header-button--icon'],
						className,
					]),
				}}
			>
				{children || <ChevronLeftIcon />}
			</IconButton>
		);
	}
	return (
		<Button
			color="inherit"
			onClick={handlePress}
			aria-label={label.toLowerCase()}
			variant="text"
			disabled={disabled}
			className={className}
			classes={{
				text: classNames([
					styles['dialog-header-button--text'],
					textClassName,
				]),
				label: styles['dialog-header-button--text-label'],
			}}
		>
			{label}
		</Button>
	);
};

export default AsaphDialogHeaderButton;
